/**
 * @Author: Nenad Brcic
 * @Date: 26.09.16
 * @Email: neno@neno.ch
 */

import React, { PropTypes } from 'react';
import RadioGroup from 'react-radio-group';

const SwitchLanguageButtons = ({ currentLang, languages, handleChange }) => (
    <RadioGroup
        name="lang"
        selectedValue={ currentLang }
        onChange={handleChange}
    >
        { Radio => (
            <div>
                {languages.sort().map(lang => (
                    <label key={lang} className={ lang === currentLang ? 'is-active' : '' } styleName="is-active" >
                        <Radio className="is-visuallyhidden" value={lang}/>
                        { lang.toUpperCase() }
                    </label>
                ))}
            </div>
        )}
    </RadioGroup>
);

SwitchLanguageButtons.propTypes = {
    currentLang: PropTypes.string.isRequired,
    languages: PropTypes.array.isRequired,
    handleChange: PropTypes.func.isRequired,
};

SwitchLanguageButtons.defaultProps = {
    languages: []
};

export default SwitchLanguageButtons;


// WEBPACK FOOTER //
// ./app/components/Main/SwitchLanguage/SwitchLanguageButtons.jsx